module.exports = __webpack_public_path__ + "img/s1.3e8c12a5.png";